// extracted by mini-css-extract-plugin
module.exports = {"collaboratorsTable":"CollaboratorsScreen_collaboratorsTable__2WGtL"};